<template>
  <v-container class="mt-5">
    <v-card outlined>
      <v-card-title>
        <span class="text-h5">Create New Class</span>
      </v-card-title>

      <v-card-text>
        <v-form @submit.prevent="submitForm" ref="form">
          <v-text-field
            v-model="form.name"
            label="Class Name"
            required
          ></v-text-field>
    <!-- Class Grade -->
    <v-autocomplete
  v-model="form.grade"
  :items="grades"
  label="Grade"
  required
  dense
  clearable
  outlined
  solo
></v-autocomplete>




 <!-- Class Level -->
 <v-select
                v-model="form.level"
                :items="levels"
                label="Level"
                required
              />
          <v-textarea
            v-model="form.description"
            label="Description"
            required
            rows="4"
          ></v-textarea>

          <v-btn type="submit" color="primary" class="mt-4">
            Create Class
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <v-alert
      v-if="submitted"
      type="success"
      class="mt-5"
      dismissible
    >
      Class created successfully!
    </v-alert>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CreateClass',
  data() {
    return {
      levels: ['Elementary', 'Middle', 'High'],
      grades: [
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
        'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
        'U', 'V', 'W', 'X', 'Y', 'Z',
        'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'
      ],
      form: {
        name: '',
        description: '',
        level:'',
        grade:'',
        display_name:'',
      },
      submitted: false
    }
  },
  watch: {
  'form.grade'(newGrade) {
    this.appendGradeToName();
  },
  'form.name'(newName) {
    this.appendGradeToName();
  }
},
  methods: {
    appendGradeToName() {
    const rawName = this.form.name.split(' (')[0].trim(); // remove existing grade suffix
    this.form.display_name = rawName; // Store raw name separately
    if (rawName && this.form.grade) {
      this.form.name = `${rawName} (${this.form.grade})`;
    } else {
      this.form.name = rawName;
    }
  },
    async submitForm() {
      try {
        const school_id = localStorage.getItem('user_id');

        if (!school_id) {
          this.$swal('error', 'School ID not found in local storage.');
          return;
        }
        console.log(this.form);
        const payload = {
          ...this.form,
          school_id: school_id
        };

        const response = await axios.post('/grade/createClass', payload);

        if (response.data.status) {
          console.log('Class created successfully:', response.data);
          this.$swal('success', 'Class created successfully!');
          this.$router.push({ name: 'list-grade' });
        } else {
          this.$swal('error', response.data.message || 'Failed to create class.');
        }
      } catch (error) {
        console.error('Error:', error);
        this.$swal('error', error.response.data.message || 'An error occurred while creating the class.');
      }
    }
  }
}
</script>
